"use client"

import { useRef, useState } from "react"
import NextImage from "next/image"
import { motion, useInView } from "framer-motion"
// import { ArrowRight } from "lucide-react"
import Link from "next/link"



import pdfSqAnnualThumb from "@/public/HeroReportsThumbnail/pdfSqAnnualThumb.png"
import pdfSqIntegratedThumb from "@/public/HeroReportsThumbnail/pdfSqIntegratedThumb.png"
import aparvaEnergy from "@/public/HeroReportsThumbnail/aparvaEnergy.png"
import Esg from "@/public/HeroReportsThumbnail/Esg.png"
import sbiFundsThumb from "@/public/HeroReportsThumbnail/sbiFundsThumb.png"
import kalyaniForgeCreative from "@/public/HeroReportsThumbnail/kalyaniForgeCreative.png"
import pdfSqSustainabilityThumb from "@/public/HeroReportsThumbnail/pdfSqSustainabilityThumb.png"
import whatIsNodi from "@/public/HeroReportsThumbnail/whatIsNodi.png"
import FailureNodi from "@/public/HeroReportsThumbnail/5FailureNodi.png"



const portfolioItems = [
  {
    title: "Adani Ports FY22",
    category: "Annual Report",
    client: "Adani Ports",
    image: pdfSqAnnualThumb,
    pdf: "/report/adani-ports-FY22.pdf",
  },
  {
    title: "GPL Sustainability Report 2025",
    category: "Sustainability Report",
    client: "Godrej Properties",
    image: pdfSqSustainabilityThumb,
    pdf: "/report/578012163-GPL-Sustainability-Report-2020-21.pdf",
  },
  {
    title: "Godrej Properties Integrated Report",
    category: "Integrated Report",
    client: "Godrej Properties",
    image: pdfSqIntegratedThumb,
    pdf: "/report/godrejPropreties-integrated-report-2021-222-ooCtjk9Rqn9C3DsqE7.pdf",
  },
  {
    title: "SBI Funds Integrated Report",
    category: "Integrated Report",
    client: "SBI Funds",
    image: sbiFundsThumb,
    pdf: "/report/sbi-annual-integrated-report-2020-21.pdf",
  },
  {
    title: "Apraava Energy Sustainability Report",
    category: "Sustainability Report",
    client: "Apraava Energy",
    image: aparvaEnergy,
    pdf: "/report/Apraava-Energy-Sustainability-Report-2020-21.pdf",
  },
  {
    title: "Bharat Forge Sustainability Report",
    category: "Sustainability Report",
    client: "Bharat Forge",
    image: kalyaniForgeCreative,
    pdf: "/report/Kalyani-forge-sustainability-report.pdf",
  },
  {
    title: "Adani Renewable Esg Report",
    category: "Esg Report",
    client: "Adani Renewable Energy",
    image: Esg,
    pdf: "/report/adani-renewable-report.pdf",
  },
  {
    title: "What is Nodinite?",
    category: "Creative Report",
    client: "Nodinite",
    image: whatIsNodi,
    pdf: "/report/What-is-Nodinite.pdf",
  },
  {
    title: "5 Integration Failures Your Monitoring Tool Won't Catch",
    category: "Creative Report",
    client: "Nodinite",
    image: FailureNodi,
    pdf: "/report/5-Integration-Failures-Your-Monitoring-Tool.pdf",
  },

  // {
  //   title: "SBI Integrated Report 2020-21",
  //   category: "Creative Report",
  //   client: "State Bank of India",
  //   image: "/thumbnails/sbi-integrated-report-2020-21.jpg",
  //   pdf: "/reports/sbi-annual-integrated-report-2020-21.pdf",
  // },
]


const categories = [
  "All",
  "Sustainability Report",
  "Esg Report",
  "Integrated Report",
  "Annual Report",
  "Creative Report",
]

export default function PortfolioSection() {
  const [activeCategory, setActiveCategory] = useState("All")
  const sectionRef = useRef<HTMLDivElement>(null)
  const isInView = useInView(sectionRef, { once: false, amount: 0.2, margin: "-100px" })

  const containerVariants = {
    hidden: { opacity: 1 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
      },
    },
  }

  const itemVariants = {
    hidden: { opacity: 1, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: "easeOut" },
    },
  }

  const filteredItems =
    activeCategory === "All" ? portfolioItems : portfolioItems.filter((item) => item.category === activeCategory)

  return (
    <section
      ref={sectionRef}
      className="md:py-20 py-16 bg-gradient-to-b from-gray-50 to-white relative overflow-hidden"
      id="portfolio"
    >
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-0 left-0 w-full h-full bg-dots-pattern opacity-5"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <motion.div
          initial="hidden"
          animate={isInView ? "visible" : "hidden"}
          variants={containerVariants}
          className="text-center mb-16"
        >
          {/* <motion.h2
            variants={itemVariants}
            className="inline-block mb-4 px-4 py-2 rounded-full bg-accent/10 text-primary font-medium text-sm"
          >
            Our Portfolio
          </motion.h2> */}

          <motion.h2 variants={itemVariants} className="text-4xl md:text-5xl font-bold text-primary mb-4">
            See What World-Class Reports Looks Like
          </motion.h2>

          <motion.p variants={itemVariants} className="text-lg text-gray-600 max-w-3xl mx-auto">
            Browse through our portfolio of award-winning report designs that have helped companies effectively
            communicate their performance and strategy to stakeholders.
          </motion.p>

          {/* Category Filter */}
          <motion.div variants={itemVariants} className="flex flex-wrap justify-center gap-3 mt-10">
            {categories.map((category, index) => (
              <button
                key={index}
                onClick={() => setActiveCategory(category)}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-all ${activeCategory === category ? "bg-primary text-white" : "bg-gray-100 text-gray-600 hover:bg-gray-200"
                  }`}
              >
                {category}
              </button>
            ))}
          </motion.div>
        </motion.div>

        <motion.div
          initial="hidden"
          animate={isInView ? "visible" : "hidden"}
          variants={containerVariants}
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"
        >
          {filteredItems.map((item, index) => (
            <motion.div
              key={index}
              variants={itemVariants}
              whileHover={{ y: -10 }}
              className="premium-card group cursor-pointer"
            >
              <Link href={item?.pdf} target="_blank" rel="noopener noreferrer" className="block">
                <div className="relative h-80 overflow-hidden">
                  <NextImage
                    src={item.image}
                    alt={item.title}
                    fill
                    className="object-cover transition-transform duration-500 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-primary/90 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-end p-6">
                    <span className="text-white/80 text-sm font-medium">{item.category}</span>
                    <h3 className="text-white text-xl font-bold mb-1">{item.title}</h3>
                    <p className="text-white/80 text-sm">Client: {item.client}</p>
                  </div>
                </div>
                <div className="p-6">
                  <span className="text-accent text-sm font-medium">{item.category}</span>
                  <h3 className="text-primary text-xl font-bold mb-1">{item.title}</h3>
                  <p className="text-gray-500 text-sm mb-4">Client: {item.client}</p>
                  {/* <button className="flex items-center text-primary font-medium group-hover:text-accent transition-colors">
                  View Details
                  <ArrowRight className="ml-2 w-4 h-4 transition-transform group-hover:translate-x-1" />
                </button> */}
                </div>
              </Link>

            </motion.div>
          ))}
        </motion.div>

        {/* <motion.div
          variants={itemVariants}
          initial="hidden"
          animate={isInView ? "visible" : "hidden"}
          className="mt-16 text-center"
        >
          <button className="premium-button">View All Projects</button>
        </motion.div> */}
      </div>
    </section>
  )
}







